import type { ColorValue } from "@@/shared/stylable/color-value";
import { colorValueFactory } from "@@/shared/stylable/color-value-factory";
import { randomInt } from "./random-int";
import { setWithinPercentageRange } from "./set-within-range";

/**
 * Generates a random color, with given (or default)
 * set of saturation, light and alpha
 */
const randomColor = (options?: {
    alpha?: number;
    saturation?: number;
    light?: number;
    /**
     * Never let color (hue) be to close to value of `requireHueDiffFrom`
     */
    requireHueDiffFrom?: number;
}): ColorValue => {
    let h = randomInt({ min: 0, max: 359 });
    if (typeof options?.requireHueDiffFrom !== "undefined") {
        const diff = Math.abs(h - options.requireHueDiffFrom);
        if (diff < 20) {
            h = (h + 20) % 360;
        }
    }
    const s = setWithinPercentageRange(options?.saturation ?? 0.7);
    const l = setWithinPercentageRange(options?.light ?? 0.65);
    const color = colorValueFactory({
        hue: h,
        saturation: s,
        light: l,
        alpha: setWithinPercentageRange(options?.alpha ?? 1),
    });
    return color;
};

export { randomColor };
